import React, { useContext } from "react";
import AlertContext from "../../../context/AlertContext";
const websites = [
  {
    websiteName: "Tpoint Tech",
    url: "https://www.tpointtech.com/",
    svg: (
      <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 24L1.6077 6L22.3923 6L12 24Z" fill="#EE0002" />
      <path
        d="M8.52841 9.40625V8.27273H15.2827V9.40625H12.5597V17H11.2472V9.40625H8.52841Z"
        fill="white"
      />
    </svg>
    ),
  },
  {
    websiteName: "W3Schools",
    url: "https://www.w3schools.com",
    svg: (
      <svg
        width="26"
        height="24"
        viewBox="0 0 26 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_7890_15039)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.3037 0.524494C21.3037 0.957303 21.5235 1.06355 22.5587 1.13124L23.8137 1.21348L23.0705 2.09393C22.2305 3.08926 22.3179 3.77528 23.2846 3.77528C23.6419 3.77528 24.0939 3.96755 24.2888 4.20243C25.0717 5.14571 23.3871 6.07524 22.1221 5.39838C21.671 5.15676 21.5321 5.1867 21.3908 5.55533C20.9286 6.75991 23.9852 7.23182 25.032 6.11757C25.9084 5.18427 25.8081 3.96297 24.7891 3.1653L23.9599 2.51649L24.6542 1.69133C25.8505 0.269393 25.639 0 23.3261 0C21.5024 0 21.3037 0.0515056 21.3037 0.524494ZM0.346283 2.35955C2.48849 6.3627 7.94458 15.9101 8.09019 15.9101C8.20076 15.9101 9.48111 13.7846 10.9354 11.187L13.5797 6.46382L14.7034 8.42292C15.3217 9.50049 16.5204 11.6257 17.3671 13.1461C18.2141 14.6664 18.9913 15.9093 19.0941 15.9085C19.3837 15.9061 21.6704 11.4769 21.5475 11.157C21.4876 11.0009 20.3464 8.91344 19.0115 6.51802L16.5846 2.16243L13.6183 2.16054L10.652 2.15865L9.43851 4.31461C8.77109 5.50031 8.16246 6.47083 8.08642 6.47137C8.0101 6.47164 7.41253 5.50112 6.7586 4.31461L5.56965 2.1573H2.90404C1.43761 2.1573 0.286957 2.24845 0.346283 2.35955ZM7.87824 21.2141C7.93109 23.0028 8.06107 23.8565 8.29244 23.9331C8.5292 24.0116 8.62952 23.6794 8.62952 22.8186C8.62952 21.8907 8.75383 21.5253 9.14053 21.3185C9.82035 20.9547 10.182 21.4091 10.2947 22.769C10.4365 24.4751 11.0565 24.315 11.0565 22.5724C11.0565 20.8687 10.6601 20.3728 9.44093 20.5515C8.65945 20.6662 8.62952 20.6327 8.62952 19.6387C8.62952 18.8904 8.51572 18.6067 8.21532 18.6067C7.86583 18.6067 7.81298 19.0153 7.87824 21.2141ZM21.034 21.3034C21.034 23.5205 21.106 24 21.4385 24C21.771 24 21.843 23.5205 21.843 21.3034C21.843 19.0862 21.771 18.6067 21.4385 18.6067C21.106 18.6067 21.034 19.0862 21.034 21.3034ZM0.553924 20.8816C0.110058 21.4164 0.600036 22.2709 1.47644 22.491C2.55132 22.7609 2.31725 23.2811 1.21379 23.074C0.0987326 22.8647 -0.0738516 23.3156 0.944126 23.7794C1.4484 24.0092 1.78817 24.0092 2.29244 23.7794C3.30718 23.3172 3.17208 22.4405 2.01199 21.9557C0.866733 21.477 1.01801 20.9817 2.23554 21.2227C3.02053 21.3783 3.06691 21.3522 2.73145 20.9444C2.27734 20.3924 0.990778 20.3552 0.553924 20.8816ZM4.2057 21.079C3.60947 21.9301 3.66826 22.8005 4.36588 23.4502C5.02008 24.0596 5.69828 24.1445 6.49756 23.7169C7.20624 23.3374 6.87833 22.8769 6.04777 23.0853C5.27815 23.2784 4.58458 22.8062 4.58458 22.0889C4.58458 21.4525 5.39869 21.0151 6.195 21.2233C6.65046 21.3425 6.78125 21.2853 6.68983 21.0073C6.62134 20.7994 6.13109 20.5923 5.60067 20.547C4.84669 20.4828 4.54197 20.599 4.2057 21.079ZM12.5744 20.9954C11.8628 21.7818 12.082 23.204 12.9932 23.7131C14.5831 24.6013 16.2421 22.9424 15.3538 21.3524C14.8253 20.4067 13.2858 20.2091 12.5744 20.9954ZM16.896 20.9876C16.2906 21.6564 16.3338 22.8054 16.9891 23.4607C18.0958 24.5674 19.9554 23.8234 19.9554 22.2736C19.9554 21.7572 19.7496 21.2006 19.4621 20.9407C18.8077 20.3482 17.4521 20.373 16.896 20.9876ZM23.2056 20.8816C22.7221 21.4644 23.0427 22.0886 23.9968 22.4211C25.135 22.8181 25.039 23.2943 23.8655 23.074C22.8065 22.8752 22.5873 23.2627 23.4861 23.7438C24.171 24.1103 25.2313 23.8854 25.4452 23.3283C25.6949 22.6776 25.3661 22.1711 24.4978 21.8686C23.5338 21.5326 23.7323 20.956 24.7262 21.2055C25.2472 21.3365 25.3883 21.2867 25.2955 21.0043C25.1186 20.4663 23.623 20.3784 23.2056 20.8816ZM13.409 21.3395C12.8185 21.6701 12.802 22.8839 13.3853 23.1077C14.4284 23.5079 15.3444 21.8664 14.3693 21.3444C14.0497 21.1734 13.7092 21.1718 13.409 21.3395ZM17.671 21.3991C17.1231 21.7998 17.2026 22.6085 17.8288 23.0028C18.4746 23.4094 19.1464 23.0335 19.1464 22.2653C19.1464 21.401 18.3266 20.9196 17.671 21.3991Z"
            fill="#04AA6D"
          />
        </g>
        <defs>
          <clipPath id="clip0_7890_15039">
            <rect width="25.8876" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    websiteName: "TutorialsPoint",
    url: "https://www.tutorialspoint.com",
    svg: (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.91751 0.212331C2.81253 1.70535 -1.51098 8.88059 0.489761 15.8587C0.846334 17.1022 1.66525 18.7573 2.43676 19.7932C3.71995 21.5164 5.67124 23.0706 7.51579 23.8387L7.90325 24L7.54014 23.397C7.00195 22.5032 6.91313 22.0938 6.92021 20.537C6.92632 19.1669 6.94188 19.0787 7.80993 15.4952C8.29587 13.4892 8.71863 11.7634 8.74953 11.6602C8.80134 11.4868 8.67079 11.4725 7.0263 11.4725H5.24708L5.30318 11.2311C5.33397 11.0984 5.48147 10.4588 5.63101 9.80978C5.78044 9.16079 5.92837 8.54536 5.95958 8.44206C6.01075 8.27321 6.19333 8.25433 7.77206 8.25433C9.35218 8.25433 9.53294 8.23556 9.58078 8.06661C9.60996 7.9633 9.8156 7.09472 10.0378 6.13635C10.3254 4.8952 10.4896 4.38019 10.6086 4.34618C11.1522 4.19096 15.5542 3.39629 15.6026 3.44456C15.6347 3.47674 15.3973 4.65652 15.075 6.0664C12.9357 15.4226 12.0849 19.3443 12.0372 20.0671C11.9093 22.0081 12.7347 22.7163 15.2438 22.8183C16.7088 22.8778 17.6188 22.7435 18.7774 22.2967C20.9097 21.4745 22.6245 19.8761 23.6512 17.7538C27.1968 10.4248 22.7423 1.68894 14.6795 0.159446C13.4533 -0.0731205 11.1547 -0.047697 9.91751 0.212331ZM16.7976 7.76217C15.944 8.07819 15.442 8.82459 15.442 9.77814C15.442 11.7946 18.1196 12.548 19.2164 10.8402C19.5023 10.3953 19.5301 10.2747 19.4961 9.62806C19.464 9.01693 19.4093 8.84927 19.1284 8.5017C18.5133 7.74071 17.6209 7.45751 16.7976 7.76217Z"
          fill="#3FA948"
        />
      </svg>
    ),
  },
   {
    websiteName: "MDN",
    url: "https://developer.mozilla.org",
    svg: (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
  >
    <g id="surface1">
      <path
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "rgb(99.607843%,99.607843%,100%)",
          fillOpacity: 1,
        }}
        d="M 15.484375 26.117188 C 10.324219 26.117188 5.21875 26.117188 0.117188 26.117188 C 0.117188 17.449219 0.117188 8.78125 0.117188 0.117188 C 8.78125 0.117188 17.449219 0.117188 26.117188 0.117188 C 26.117188 8.78125 26.117188 17.449219 26.117188 26.117188 C 22.589844 26.117188 19.066406 26.117188 15.484375 26.117188 M 10.441406 2.894531 C 10.386719 2.890625 10.335938 2.890625 10.179688 2.867188 C 9.441406 2.875 8.707031 2.882812 7.910156 2.890625 C 7.894531 2.925781 7.882812 2.964844 7.832031 3.082031 C 6.140625 8.539062 4.445312 13.996094 2.761719 19.457031 C 2.394531 20.644531 2.066406 21.84375 1.648438 23.082031 C 1.675781 23.167969 1.703125 23.253906 1.839844 23.359375 C 2.574219 23.351562 3.308594 23.34375 4.109375 23.339844 C 4.125 23.300781 4.140625 23.265625 4.199219 23.15625 C 4.898438 20.90625 5.605469 18.65625 6.304688 16.40625 C 7.664062 12.015625 9.019531 7.621094 10.402344 3.167969 C 10.4375 3.121094 10.472656 3.070312 10.503906 3.074219 C 10.503906 3.074219 10.527344 3.121094 10.515625 3.179688 C 10.515625 3.179688 10.53125 3.230469 10.515625 3.339844 C 10.511719 8.625 10.511719 13.910156 10.511719 19.195312 C 10.511719 20.539062 10.523438 21.886719 10.527344 23.292969 C 10.5625 23.308594 10.59375 23.320312 10.734375 23.355469 C 11.394531 23.351562 12.054688 23.34375 12.785156 23.339844 C 12.800781 23.300781 12.8125 23.265625 12.835938 23.117188 C 12.835938 17.121094 12.835938 11.128906 12.835938 5.132812 C 12.835938 4.421875 12.820312 3.710938 12.816406 2.9375 C 12.78125 2.921875 12.746094 2.90625 12.605469 2.867188 C 11.945312 2.875 11.289062 2.882812 10.570312 2.878906 C 10.550781 2.890625 10.535156 2.902344 10.441406 2.894531 M 21.867188 2.878906 C 21.78125 2.882812 21.695312 2.886719 21.503906 2.867188 C 20.769531 2.875 20.03125 2.882812 19.234375 2.890625 C 19.21875 2.929688 19.207031 2.964844 19.15625 3.082031 C 18.40625 5.496094 17.648438 7.90625 16.902344 10.324219 C 15.585938 14.585938 14.273438 18.851562 12.929688 23.191406 C 12.972656 23.242188 13.015625 23.289062 13.164062 23.359375 C 13.898438 23.351562 14.632812 23.34375 15.445312 23.328125 C 15.464844 23.257812 15.484375 23.1875 15.5625 23.058594 C 16.773438 19.140625 17.988281 15.222656 19.195312 11.304688 C 20.046875 8.542969 20.890625 5.777344 21.78125 2.996094 C 21.78125 2.996094 21.828125 3.011719 21.824219 3.117188 C 21.828125 9.304688 21.828125 15.488281 21.832031 21.675781 C 21.832031 22.191406 21.84375 22.710938 21.847656 23.292969 C 21.882812 23.308594 21.917969 23.320312 22.0625 23.359375 C 22.679688 23.351562 23.300781 23.34375 23.976562 23.347656 C 23.976562 23.347656 24.03125 23.332031 24.125 23.296875 C 24.132812 23.238281 24.144531 23.179688 24.144531 23.125 C 24.144531 16.515625 24.144531 9.90625 24.140625 3.296875 C 24.140625 3.164062 24.070312 3.03125 23.976562 2.875 C 23.957031 2.878906 23.941406 2.882812 23.8125 2.867188 C 23.195312 2.875 22.574219 2.882812 21.867188 2.878906 Z M 21.867188 2.878906"
      />
      <path
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "rgb(9.803922%,44.313726%,94.117647%)",
          fillOpacity: 1,
        }}
        d="M 10.378906 3.230469 C 9.019531 7.621094 7.664062 12.015625 6.304688 16.40625 C 5.605469 18.65625 4.898438 20.90625 4.152344 23.203125 C 4.074219 23.273438 4.054688 23.300781 4.046875 23.335938 C 3.308594 23.34375 2.574219 23.351562 1.785156 23.296875 C 1.726562 23.171875 1.722656 23.105469 1.71875 23.035156 C 2.066406 21.84375 2.394531 20.644531 2.761719 19.457031 C 4.445312 13.996094 6.140625 8.539062 7.875 3.03125 C 7.945312 2.957031 7.964844 2.925781 7.972656 2.890625 C 8.707031 2.882812 9.441406 2.875 10.230469 2.917969 C 10.316406 3.050781 10.347656 3.140625 10.378906 3.230469 Z M 10.378906 3.230469"
      />
    </g>
  </svg>
    ),
  },
];
function RecommendedWebsites() {
  const { setOpenRecommendedList } = useContext(AlertContext);
  function handleCloseRecommended() {
    setOpenRecommendedList(false);
  }

  return (
    <div className="recommendedWebsitesMainContainer">
      <div className="recommendedWebsitesContainer">
        <div>
          <div className="titleOfSectionContainer">
            <span className="titleOfSection">
              Reference help from external websites
            </span>
            <svg
              className="closeIcon"
              onClick={() => handleCloseRecommended()}
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 9L9 19M9 9L19 19"
                stroke="#F2F4F7"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <span className="description">
            Only these websites are allowed to be accessed for reference.
          </span>
        </div>
        <div className="recommendedWebsites">
          {websites.map((site, index) => (
            <div
              key={index}
              className="recommendedWebsite"
              onClick={() => window.open(site.url, "_blank")}
              role="button"
              tabIndex={0}
            >
              <div className="iconandtitle">
                {site.svg}
                <p className="websiteTitle">{site.websiteName}</p>
              </div>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5 4.5L10.5 1.5M10.5 1.5H7.49999M10.5 1.5L6 6M5 1.5H3.9C3.05992 1.5 2.63988 1.5 2.31901 1.66349C2.03677 1.8073 1.8073 2.03677 1.66349 2.31901C1.5 2.63988 1.5 3.05992 1.5 3.9V8.1C1.5 8.94008 1.5 9.36012 1.66349 9.68099C1.8073 9.96323 2.03677 10.1927 2.31901 10.3365C2.63988 10.5 3.05992 10.5 3.9 10.5H8.1C8.94008 10.5 9.36012 10.5 9.68099 10.3365C9.96323 10.1927 10.1927 9.96323 10.3365 9.68099C10.5 9.36012 10.5 8.94008 10.5 8.1V7"
                  stroke="#667085"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default RecommendedWebsites;